import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import * as superAdminApi from '@/services/api/endpoints/superAdmin'
import { PlatformStats } from '@/services/api/endpoints/superAdmin'
import { ApiError } from '@/services/api/types'
import { RootState } from '@/store/store'

interface SuperAdminState {
  error: string | null
  stats: PlatformStats | null
  statsLoading: boolean
}

const initialState: SuperAdminState = {
  error: null,
  stats: null,
  statsLoading: false,
}

const errorMessage = (error: unknown, fallback: string): string => (error instanceof ApiError ? error.message : fallback)

export const fetchPlatformStats = createAsyncThunk('superAdmin/fetchStats', async (_, { rejectWithValue }) => {
  try {
    return await superAdminApi.getPlatformStats()
  } catch (error) {
    return rejectWithValue(errorMessage(error, 'Failed to load platform stats'))
  }
})

const superAdminSlice = createSlice({
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlatformStats.pending, (state) => {
        state.statsLoading = true
      })
      .addCase(fetchPlatformStats.fulfilled, (state, action) => {
        state.stats = action.payload
        state.statsLoading = false
      })
      .addCase(fetchPlatformStats.rejected, (state, action) => {
        state.statsLoading = false
        state.error = action.payload as string
      })
  },
  initialState,
  name: 'superAdmin',
  reducers: {},
})

export const selectPlatformStats = (state: RootState): PlatformStats | null => state.superAdmin.stats
export const selectPlatformStatsLoading = (state: RootState): boolean => state.superAdmin.statsLoading

export default superAdminSlice.reducer
